import React, { useEffect } from "react";
import "./OnlineRegistration.css";
import { ToastContainer, toast } from "react-toastify";
// import emailjs from "@emailjs/browser";
// import Aos from "aos";

const Registration = () => {
  useEffect(() => {
    document.title = "Online Registration";
  });
  const onSubmit = async (event) => {
    
    event.preventDefault();
    const formData = new FormData(event.target);

    formData.append("access_key", "ee8fa2ec-efa3-4347-a8ac-cbc23c369239");

    const object = Object.fromEntries(formData);
    const json = JSON.stringify(object);

    const res = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: json,
    }).then((res) => res.json());

    if (res.success) {
      toast.success('Login successfully', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
        // transition: Bounce,
        });
    } else {
      alert("Failed", res);
    }
  };

  return (
    <>
      <div className="container-fluid bg-img-11">
        <h2 className="main-1-heading text-center">Online Registration</h2>
      </div>

      <section className="contact " id="contact">
        <div className="container text-center registration-container-">
          <div className="col-sm-12 col-lg-10 text-center container">
            <h1 className="text-center main--heading">
              Student Registration Form
            </h1>

            <form onSubmit={onSubmit}>
              {/* onSubmit={handleSubmit} */}
              <div className="row">
                <div className="col-sm-6">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Name"
                    id="name"
                    name="name"
                    // value={formData.name}
                    // onChange={handleChange}
                    required
                  />
                </div>
                <div className="col-sm-6">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Father Name"
                    id="name"
                    name="f-name"
                    // value={formData.name}
                    // onChange={handleChange}
                    required
                  />
                </div>
                <div className="col-sm-6">
                  <input
                    type="email"
                    className="form-control"
                    placeholder="Email"
                    id="email"
                    name="email"
                    //  value={formData.email}
                    //  onChange={handleChange}
                    required
                  />
                </div>
                <div className="col-sm-6">
                  <input
                    type="number"
                    className="form-control"
                    id="age"
                    name="age"
                    placeholder="Age"
                    required
                  />
                </div>
                <div className="col-sm-6">
                  <select
                    name="gender"
                    id="gender"
                    className="form-control"
                    required
                  >
                    <option value="">Gender</option>
                    <option value="male">Male</option>
                    <option value="female">Female</option>
                    <option value="other">Other</option>
                  </select>
                </div>
                <div className="col-sm-6">
                  <input
                    className="form-control"
                    type="tel"
                    id="phone"
                    placeholder=" (+44-123-456-7890)"
                    name="phone"
                    // value={formData.phone}
                    // onChange={handleChange}
                    required
                  />
                </div>
                <div className="col-sm-6">
                  <input
                    type="text"
                    name="country"
                    id="country"
                    className="form-control"
                    placeholder="Country"
                    required
                  />
                </div>
                <div className="col-sm-6">
                  <input
                    name="address"
                    placeholder="Adress"
                    className="form-control"
                    required
                  />
                </div>
                <div className="col-sm-6">
                  <select
                    name="selection"
                    className="form-control"
                    // value={formData.selection}
                    // onChange={handleChange}
                    required
                  >
                    <option value="">Plese select a course</option>
                    <option value="Basis Qaida For  Bigners">
                      Basis Qaida For Bigners
                    </option>
                    <option value="Quran Recitation ">Quran Recitation </option>
                    <option value="Quran Memorization">
                      Quran Memorization
                    </option>
                    <option value=" Quran Tafseer"> Quran Tafseer</option>
                    <option value="Quran Tajweed ">Quran Tajweed </option>
                    <option value="Quran With Translation">
                      Quran With Translation
                    </option>
                  </select>
                </div>

                {/* <div className="col-sm-6">
                    <input type="text" className="form-control" placeholder="Subject"
                     id="subject"
                     name="name"
                    //  value={formData.subject}
                    //  onChange={handleChange}
                     required />
                  </div> */}
              </div>
              <div className="form-group">
                {/* id="comment" */}
                <textarea
                  className="form-control"
                  rows={5}
                  placeholder="Message"
                  id="message"
                  name="message"
                  //  value={formData.message}
                  //  onChange={handleChange}
                  required
                />
                {/* defaultValue={""} */}
              </div>
              <button className="btn btn-block mt-3" type="submit">
                Send Now!
              </button>
              <button className="btn btn-block ms-2 mt-3" type="reset">
                Reset
              </button>
            </form>
          </div>
        </div>
        <ToastContainer/>
      </section>
    </>
  );
};

export default Registration;
